import { Box, styled } from '@mui/material';

export const ApptRequestsTitle = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%'
});
